module.exports = __webpack_public_path__ + "img/feature_buy_zh.f31a4760.png";